import { LocalTimeRange } from '@ftr/contracts/type/shared'
import { DateFormat, jodaFormatPatternWithLocale } from '@ftr/foundation'
import { LocalTime } from '@js-joda/core'

/** LocalTimeRange requires an end time. We use LocalTime.MAX as a proxy for "no end time" i.e. ongoing */
export const ONGOING_END_TIME_PROXY = LocalTime.MAX

export const REQUEST_TIME_FORMAT = jodaFormatPatternWithLocale(DateFormat.TimeWithSeconds)

export function isOngoingEnd(endTime: LocalTime | null | undefined): boolean {
  if (!endTime) return false
  return endTime.equals(ONGOING_END_TIME_PROXY)
}

export function formatRequestTimeRange(timeRange: LocalTimeRange): string {
  return `${timeRange.start.format(REQUEST_TIME_FORMAT)} - ${isOngoingEnd(timeRange.end) ? 'Ongoing' : timeRange.end.format(REQUEST_TIME_FORMAT)}`
}
